import { createActionsGroup } from 'utils/redux-utils'

export const subscribeToProductActions = createActionsGroup(
  'SUBSCRIBE_TO_PRODUCT',
)

export const productDetailsActions = createActionsGroup('PRODUCT_DETAILS')
